<template>
  <v-select
    v-model="selectedValue"
    :items="iconOptions"
    label="Выберите иконку"
    dense
    outlined
    prepend-icon="mdi-palette"
    item-text="text"
    item-value="value"
  >
    <template v-slot:selection="{ item }">
      <div class="d-flex align-center">
        <v-icon class="mr-2">{{ item.icon }}</v-icon>
        <span>{{ item.text }}</span>
      </div>
    </template>
    <template v-slot:item="{ item }">
      <div class="d-flex align-center">
        <v-icon class="mr-3">{{ item.icon }}</v-icon>
        <div>
          <div class="font-weight-medium">{{ item.text }}</div>
          <div class="caption text--secondary">{{ item.description }}</div>
        </div>
      </div>
    </template>
  </v-select>
</template>

<script>
export default {
  name: 'IconSelector',
  props: {
    value: {
      type: String,
      default: 'mdi-information',
    },
  },
  computed: {
    selectedValue: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue);
      },
    },
  },
  data () {
    return {
      iconOptions: [
        { value: 'mdi-information', icon: 'mdi-information', text: 'Информация', description: 'Общая информация' },
        { value: 'mdi-newspaper', icon: 'mdi-newspaper', text: 'Новости', description: 'Новости и события' },
        { value: 'mdi-update', icon: 'mdi-update', text: 'Обновление', description: 'Обновления системы' },
        { value: 'mdi-shield-check', icon: 'mdi-shield-check', text: 'Безопасность', description: 'Безопасность и защита' },
        { value: 'mdi-bell', icon: 'mdi-bell', text: 'Уведомления', description: 'Уведомления и оповещения' },
        { value: 'mdi-star', icon: 'mdi-star', text: 'Важное', description: 'Важная информация' },
        { value: 'mdi-check-circle', icon: 'mdi-check-circle', text: 'Успех', description: 'Успешное выполнение' },
        { value: 'mdi-alert', icon: 'mdi-alert', text: 'Предупреждение', description: 'Предупреждения' },
        { value: 'mdi-help', icon: 'mdi-help', text: 'Помощь', description: 'Справка и помощь' },
        { value: 'mdi-cog', icon: 'mdi-cog', text: 'Настройки', description: 'Настройки системы' },
        { value: 'mdi-home', icon: 'mdi-home', text: 'Главная', description: 'Главная страница' },
        { value: 'mdi-phone', icon: 'mdi-phone', text: 'Телефон', description: 'Контактная информация' },
        { value: 'mdi-calendar', icon: 'mdi-calendar', text: 'Календарь', description: 'Даты и события' },
        { value: 'mdi-clock', icon: 'mdi-clock', text: 'Время', description: 'Время и часы' },
        { value: 'mdi-map-marker', icon: 'mdi-map-marker', text: 'Местоположение', description: 'Геолокация' },
        { value: 'mdi-bookmark', icon: 'mdi-bookmark', text: 'Закладка', description: 'Закладки' },
        { value: 'mdi-lock', icon: 'mdi-lock', text: 'Блокировка', description: 'Безопасность и доступ' },
        { value: 'mdi-check', icon: 'mdi-check', text: 'Подтвердить', description: 'Подтверждение' },
        { value: 'mdi-refresh', icon: 'mdi-refresh', text: 'Обновить', description: 'Обновление' },
        { value: 'mdi-image', icon: 'mdi-image', text: 'Изображение', description: 'Изображения' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.v-select {
  .v-input__slot {
    .v-select__selections {
      .v-select__selection {
        .v-icon {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
